/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function Yield(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'Yield',
      'aria-hidden': true,
      focusable: false,
      width:  12 * scale,
      height: 10 * scale,
      viewBox: '0 0 12 10',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"d":"M7.804 9c-.77 1.333-2.694 1.333-3.464 0L.876 3c-.77-1.333.192-3 1.732-3h6.928c1.54 0 2.502 1.667 1.732 3z","fill":"currentColor"}))
}
